import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SeguimientoService } from '../../../services/seguimiento/seguimiento.service';
import { HttpErrorResponse } from '@angular/common/http';
import { supplierIntegrationService } from '../../../services/supplierIntegration/supplier-integration.service';

@Component({
  selector: 'app-view-fe',
  templateUrl: './view-fe.component.html',
  standalone: false,
  styleUrls: ['./view-fe.component.scss']
})
export class ViewFEComponent implements OnInit {
  loadMenu: boolean = true;
  load: boolean = false;
  lsInfo: Array<any> = [];
  lsInfoIntegration: any = {};
  msgError: string = "";

  constructor(private router: ActivatedRoute,
    private seguimiento: SeguimientoService,
    private integration: supplierIntegrationService
  ) { }

  ngOnInit(): void {
    this.router.params.subscribe(params => {
      this.load = true;
      let idVenta:number = parseInt(atob(params["idVenta"]));
      /// iniciar el proceso de dato.
      this.seguimiento.getVenta(idVenta).subscribe({
        next: (response) => {
          this.lsInfo = response as Array<any>;
          // información de SIIGO
          this.integration.getSaleSiigoNoAut(this.lsInfo[0]?.integration?.idIntegracion, this.lsInfo[0]?.proveedor)
            .subscribe({
              next: (response1) => {
                this.lsInfoIntegration = response1 as any;
                this.load = false;
              },
              error: (error: HttpErrorResponse) => {
                this.load = false;
                this.msgError = "<div class='p-message p-message-info p-4'>Se ha presentado un error, favor intente en 10 mínutos</div>"
              }
            })
        },
        error: (error: HttpErrorResponse) => {
          this.load = false;
          this.msgError = "<div class='p-message p-message-info p-4'>Se ha presentado un error, favor intente en 10 mínutos</div>"
        }
      })
    });
  }

  download = () => {
    window.open(this.lsInfoIntegration?.public_url);
  }

}
